import { Div, Icon, Text } from "atomize"
import { useContext, useState } from "react"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import { profileContext } from "../providers/profile.provider"
import { schoolContext } from "../providers/school.provider"
import Dropdown from "../atomize/Dropdown"
import Divider from "../atoms/Divider"
import CoachAvatar from "../atoms/CoachAvatar"
import { isSmartphone } from "../atoms/SmartphoneView"
import { canSwitchDisplayedCoach, getViewableCoaches } from "../utils/func.utils"

// Sul telefono, chi guarda le lezioni e i numeri di quale maestro: "Tu" o un
// collega. Sta sopra la barra in fondo (delle lezioni o del profilo), dentro
// lo stesso blocco fisso, così sale con lei quando sopra le compare un
// avviso. Prima galleggiava a un'altezza fissa e l'avviso ci finiva sotto.
export const useShowPhoneCoachDropdown = () => {
	const { coach, displayedCoachID } = useContext(profileContext)
	const { getSelectedSchool, selectedSchool } = useContext(schoolContext)

	return (
		isSmartphone &&
		!!displayedCoachID &&
		canSwitchDisplayedCoach(coach, getSelectedSchool(), selectedSchool)
	)
}

function PhoneCoachDropdown() {
	const { coach, displayedCoachID, setDisplayedCoachID } = useContext(profileContext)
	const { getSelectedSchool, selectedSchool } = useContext(schoolContext)
	const [isOpen, setIsOpen] = useState(false)

	if (!useShowPhoneCoachDropdown()) return null

	// solo chi si può guardare: vedere le lezioni di un collega non vuol dire
	// vedere quelle di tutti
	const coaches = getViewableCoaches(coach, getSelectedSchool(), selectedSchool)
	const coachOf = coachID =>
		coachID === coach.coachID ? coach : getSelectedSchool()?.coaches[coachID]
	const coachLabel = coachID =>
		getSelectedSchool()?.coaches[coachID]?.coachName === coach.coachName
			? "Tu"
			: getSelectedSchool()?.coaches[coachID]?.coachName

	return (
		<Div d="flex" justify="flex-end" m={{ b: "0.5rem" }}>
			<motion.div
				whileTap={{ scale: 0.9 }}
				initial={{ opacity: 0, scale: 0 }}
				animate={{ opacity: 1, scale: 1 }}
				exit={{ opacity: 0 }}>
				<Dropdown
					w="fit-content"
					p="1.5rem 0.75rem"
					rounded={"20px"}
					bg="primary"
					focusBg="primary"
					direction="topright"
					borderColor={theme.colors.primary}
					focusBorderColor={theme.colors.primary}
					textColor={"white"}
					isOpen={isOpen}
					shadow={theme.shadows.accent}
					openSuffix={<Icon name="DownArrow" size="18px" m={{ l: "1rem" }} color="white" />}
					closeSuffix={<Icon name="UpArrow" size="18px" m={{ l: "1rem" }} color="white" />}
					onClick={() => setIsOpen(!isOpen)}
					menu={coaches.map((coachForSchool, i) => (
						<>
							<Text
								key={coachForSchool.coachID}
								d="flex"
								align="center"
								p="0.6rem 1rem"
								textAlign="left"
								style={{ gap: "0.6rem" }}
								onClick={() => {
									setDisplayedCoachID(coachForSchool.coachID)
									setIsOpen(false)
								}}>
								<CoachAvatar coach={coachOf(coachForSchool.coachID)} size={32} />
								<span>{coachLabel(coachForSchool.coachID)}</span>
							</Text>
							{i < coaches.length - 1 && (
								<Divider
									m={{ x: "0.5rem" }}
									w="2px solid"
									borderColor={theme.colors.background}
								/>
							)}
						</>
					))}>
					<Div
						w="fit-content"
						d="flex"
						align="center"
						style={{ gap: "0.5rem" }}
						textWeight="normal">
						{/* la foto di chi si guarda, con un filo bianco che la
						    stacca dall'arancione */}
						<CoachAvatar
							coach={coachOf(displayedCoachID)}
							size={30}
							style={{ boxShadow: `0 0 0 2px ${theme.colors.white}` }}
						/>
						<Text textAlign="left">{coachLabel(displayedCoachID)}</Text>
					</Div>
				</Dropdown>
			</motion.div>
		</Div>
	)
}

export default PhoneCoachDropdown
